
import { useState, useEffect, useRef } from 'react';
import { fetchWinterClosedRoads } from '../services/nvdbService';
import { WinterClosedRoad, MapBounds } from '../types';
import { boundsOverlapRatio } from '../utils/boundsUtils';

export const useWinterRoads = (
  active: boolean,
  zoom: number,
  currentViewBounds: MapBounds | null
) => {
  const [roads, setRoads] = useState<WinterClosedRoad[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const lastFetchedBoundsRef = useRef<MapBounds | null>(null);

  useEffect(() => {
    if (!active || zoom < 9 || !currentViewBounds) {
      if (!active) { setRoads([]); setError(false); lastFetchedBoundsRef.current = null; }
      return;
    }

    if (lastFetchedBoundsRef.current && boundsOverlapRatio(lastFetchedBoundsRef.current, currentViewBounds) > 0.7) {
      return;
    }

    const loadRoads = async () => {
      setIsLoading(true);
      try {
        const data = await fetchWinterClosedRoads(currentViewBounds);
        setRoads(data);
        setError(false);
        lastFetchedBoundsRef.current = currentViewBounds;
      } catch (err) {
        console.error("Failed to load winter closed roads:", err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    const timer = setTimeout(loadRoads, 800);
    return () => clearTimeout(timer);
  }, [currentViewBounds, active, zoom]);

  return { roads, isLoading, error };
};
